import { useRef, useState } from "react";

function AccordionItem({ title, company, years, text, isOpen, onClick }) {
    const contentHeight = useRef(null);

    return (
        <div className="overflow-hidden border-b border-gray-200">
            <button
                className="flex justify-between items-center w-full gap-4 py-6 md:py-8 cursor-pointer"
                onClick={onClick}
            >
                <div>
                    <p className={`text-2xl md:text-3xl font-medium text-left transition-all duration-300 mb-2 hover:text-customPurple hover:opacity-80 ${isOpen ? "text-customPurple hover:opacity-100" : "text-customBlack opacity-100"}`}>{title}</p>
                    <div className="text-left">{company} {" "} | {" "} {years}</div>
                </div>
                
                <div
                    className="w-[40px] h-[40px] md:w-[54px] md:h-[54px] flex justify-center items-center shrink-0"
                >
                    <img
                        loading="lazy"
                        src={isOpen ? "./Chevron-filled.svg" : "./Chevron.svg"}
                        alt="chevron"
                        className="w-full h-full"
                    />
                </div>
            </button>

            <div
                ref={contentHeight}
                className="overflow-hidden transition-all duration-700 ease-in-out"
                style={{ height: isOpen ? contentHeight.current?.scrollHeight : "0px" }}
            >
                <p
                    className="pb-8 text-md lg:text-lg text-gray-700"
                    dangerouslySetInnerHTML={{ __html: text }}
                ></p>
            </div>
        </div>
    );
}

export default function Accordion({ items, maxWidth }) {
    const [openIndices, setOpenIndices] = useState([0]);

    const handleItemClick = (index) => {
        setOpenIndices((prevOpenIndices) => {
            if (prevOpenIndices.includes(index)) {
                // Remove index (close it)
                return prevOpenIndices.filter((i) => i !== index);
            } else {
                // Add index (open it)
                return [...prevOpenIndices, index];
            }
        });
    };

    return (
        <div className={`w-full mx-auto`} style={{ maxWidth: maxWidth ? `${maxWidth}px` : "none" }}>
            {items.map((item, i) => (
                <AccordionItem
                    key={i}
                    title={item.title}
                    company={item.company}
                    years={item.years}
                    text={item.text}
                    isOpen={openIndices.includes(i)}
                    onClick={() => handleItemClick(i)}
                />
            ))}
        </div>
    );
}
